import AXIOS from "./axios";

export class Prescriptions {
  static postPrescription(data) {
    return AXIOS.post("/admin/prescriptions", data);
  }

  static fetchPatientPrescriptions() {
    return AXIOS.get("/prescriptions");
  }

  // Receitas emitidas pelo médico logado; opcionalmente filtradas por consulta.
  static fetchDoctorPrescriptions(appointmentId) {
    const query = appointmentId ? `?appointment_id=${appointmentId}` : "";
    return AXIOS.get(`/admin/prescriptions${query}`);
  }

  // Reenvia manualmente a receita para o parceiro (farmácia) da unidade.
  static resendPrescription(prescriptionId) {
    return AXIOS.post(`/admin/prescriptions/${prescriptionId}/resend`);
  }
}
